import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

const initialState = {
    loading: false,
    success: false,
    NewDocumentError: false,
    reload: false,
    status: false,
    error: '',
    message: '',
    document: [],
    documents: [],
    documentData: [],
    printData: [],
    errorName: '',
    errorFamily: '',
    errorNationalId: '',
    errorMobile: '',
    errorDescription: '',
    errorNumberType: '',
    errorNumber: '',
    errorPartOne: '',
    errorPartTwo: '',
    errorPartThree: '',
    error_mt_bodyno: '',
    error_mt_motorno: '',
    error_mt_pelakno: '',
    error_mt_sanadno: '',
    errorStatus: '',
    errorTransferToStore: '',
    errorUploadType: ''
}

export const fetchProductDataWithId = createAsyncThunk(
    'fetchProductDataWithId',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/print`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const searchByRequest = createAsyncThunk(
    'searchByRequest',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/item/search`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentTransferFileUload = createAsyncThunk(
    'documentTransferFileUload',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}document/transfer/file/upload`,
                data: data,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true, 
                }
            })

            return await response.data
            
        } catch(error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentShow = createAsyncThunk(
    'documentShow',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}document/${data.id}`,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentStore = createAsyncThunk(
    'document/store',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/update/section`,
                data: data,
                headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }    
                })
                
            return await response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentIndex = createAsyncThunk(
    'document/index',
    async(token, thunkAPI) => {
        try {
            const response = await axios({ 
                method: 'GET',
                url: `${host}document`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,     
                }
            })

            return response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const fetchDataMotorCycle = createAsyncThunk(
    'fetchDataMotorCycle',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                // Option One
                url: `${host}fetchdatafromcompany`,
                // Option Two
                // url: 'http://127.0.0.1/remote-database/fetch.php',
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,   
                }
            })
    
            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentStatusUpdate = createAsyncThunk(
    'documentStatusUpdate',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true, 
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const documentSlice = createSlice({
    name: 'document',
    initialState,
    reducers: {

    },
    extraReducers: {
        [documentTransferFileUload.fulfilled] : (state, action) => {
            state.loading = false
            state.success = true
            state.customerStore = true
            state.message = action.payload.message
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentTransferFileUload.pending] : (state) => {
            state.loading = true
            state.success = false
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentTransferFileUload.rejected] : (state, action) => {
            state.loading = false
            state.success = false
            state.NewDocumentError = true;
            state.reload = false;
            if(action.payload.response.data.error){

                state.errorDocumentId = action.payload.response.data.error.documentId
                state.errorFile = action.payload.response.data.error.file
                state.errorUploadType = action.payload.response.data.error.uploadType

            }else if(action.payload.response.data.message) {

                state.message = action.payload.response.data.message
                
            }
        },
        [documentStore.fulfilled]: (state, {payload}) => {
            state.loading = false;
            state.success = true;
            state.message = payload.message;
            state.reload = true;
            state.NewDocumentError = false;

            state.documentData = []
        },
        [documentStore.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.reload = false;
            state.NewDocumentError = false;
            state.message = ""
        },
        [documentStore.rejected]: (state, {payload}) => {

            state.reload = false;
            state.loading = false;
            state.success = false;
            state.NewDocumentError = true;
            state.message = payload.response.data.message;
        },
        [documentIndex.fulfilled]: (state, action) => {
            
            state.loading = false
            state.documents = action.payload.data
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentIndex.pending]: (state) => {
            state.loading = true
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentIndex.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.NewDocumentError = true;
            state.reload = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [fetchDataMotorCycle.fulfilled]: (state, action) => {
            state.loading = false
            state.documentData = action.payload.data
            if(action.payload.message)
            state.message = action.payload.message;
            state.NewDocumentError = false;
            state.reload = false;
        },
        [fetchDataMotorCycle.pending]: (state) => {
            state.loading = true
            state.documentData = []
            state.NewDocumentError = false;
            state.reload = false;
        },
        [fetchDataMotorCycle.rejected]: (state, action) => {
            state.loading = false;
            state.success = false
            state.NewDocumentError = true;
            state.reload = false;
            if(action.payload.response.data.error){
                state.error = action.payload.response.data.error
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        },
        [documentStatusUpdate.fulfilled]: (state, action) => {
            state.loading = false
            state.update = true
            state.message = action.payload.message
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentStatusUpdate.pending]: (state) => {
            state.loading = true
            state.update = false
            state.NewDocumentError = false;
            state.reload = false;
        },
        [documentStatusUpdate.rejected]: (state, action) => {
            state.loading = false
            state.update = false
            state.NewDocumentError = true;
            state.reload = false;
            if(action.payload.response.data.error){
                state.errorStatus = action.payload.response.data.error.status
            } else if(action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        },
        [documentShow.fulfilled] : (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = true;
            state.reload = false;
            state.document = action.payload.data
            state.NewDocumentError = false;
        },
        [documentShow.pending]: (state) => {
            state.loading = true;
            state.success = false;
            state.status = false;
            state.reload = false;
            state.NewDocumentError = false;
        },
        [documentShow.rejected]: (state, action) => {
            state.loading = false;
            state.success = false;
            state.status = false;
            state.reload = false;
            state.NewDocumentError = true;
            if(action.payload.response.data.error) {
                state.error = action.payload.response.data.error
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        },
        [searchByRequest.fulfilled]: (state, action) => {

            state.loading = false
            state.success = true
            state.status = true
            state.reload = false;
            state.documents = action.payload.data
            state.NewDocumentError = false;
        },
        [searchByRequest.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
            state.reload = false;
            state.NewDocumentError = false;
        },
        [searchByRequest.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = false
            state.reload = false;
            state.NewDocumentError = true;
            if(payload.response.data.error){
                state.errorNumber = payload.response.data.number
                state.errorTypeNumber = payload.response.data.numberType
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [fetchProductDataWithId.fulfilled]: (state, action) => {
            state.loading = false
            state.printData = action.payload.data
            if(action.payload.data)
            state.message = action.payload.message;
            state.NewDocumentError = false;
            state.reload = false;
        },
        [fetchProductDataWithId.pending]: (state) => {
            state.loading = true
            state.documentData = []
            state.NewDocumentError = false;
            state.reload = false;
        },
        [fetchProductDataWithId.rejected]: (state, action) => {
            state.loading = false;
            state.success = false
            state.NewDocumentError = true;
            state.reload = false;
            if(action.payload.response.data.error){
                state.error = action.payload.response.data.error
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        },
    }
})

export const {} = documentSlice.actions;
export default documentSlice.reducer; 